import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { v1 } from 'uuid';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import { LinkStyle, HighlightStyle } from '@micromag/core/components';
import { getStyleFromLink, getStyleFromHighlight, getStyleFromText, getStyleFromMargin } from '@micromag/core/utils';

var styles = {"container":"micromag-element-heading-container"};

var propTypes = {
  size: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  body: PropTypes.string,
  textStyle: PropTypes$1.textStyle,
  linksStyle: PropTypes$1.textStyle,
  margin: PropTypes$1.margin,
  className: PropTypes.string,
  headingRef: PropTypes.shape({})
};
var defaultProps = {
  size: 1,
  body: null,
  textStyle: null,
  linksStyle: null,
  margin: null,
  className: null,
  headingRef: null
};
var Heading = function Heading(_ref) {
  var size = _ref.size,
    body = _ref.body,
    textStyle = _ref.textStyle,
    linksStyle = _ref.linksStyle,
    margin = _ref.margin,
    className = _ref.className,
    headingRef = _ref.headingRef;
  var HeadingComponent = "h".concat(size);
  var _ref2 = textStyle || {},
    _ref2$link = _ref2.link,
    linkStyle = _ref2$link === void 0 ? null : _ref2$link,
    _ref2$highlight = _ref2.highlight,
    highlightStyle = _ref2$highlight === void 0 ? null : _ref2$highlight;
  var finalStyle = null;
  var finalLinkStyle = linkStyle !== null ? getStyleFromLink(linkStyle) : null;
  var finalHighlightStyle = highlightStyle !== null ? getStyleFromHighlight(highlightStyle) : null;
  if (textStyle !== null) {
    finalStyle = _objectSpread(_objectSpread({}, finalStyle), getStyleFromText(textStyle));
  }
  if (margin !== null) {
    finalStyle = _objectSpread(_objectSpread({}, finalStyle), getStyleFromMargin(margin));
  }
  if (linksStyle !== null) {
    finalLinkStyle = _objectSpread(_objectSpread({}, finalLinkStyle), getStyleFromText(linksStyle));
  }
  var needsId = finalLinkStyle !== null || highlightStyle !== null;
  var id = useMemo(function () {
    return needsId ? "text-component-".concat(v1()) : null;
  }, [needsId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, finalLinkStyle !== null ? /*#__PURE__*/React.createElement(LinkStyle, {
    selector: "#".concat(id),
    style: finalLinkStyle
  }) : null, finalHighlightStyle !== null ? /*#__PURE__*/React.createElement(HighlightStyle, {
    selector: "#".concat(id),
    style: finalHighlightStyle
  }) : null, /*#__PURE__*/React.createElement(HeadingComponent, {
    id: id,
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    style: finalStyle,
    dangerouslySetInnerHTML: {
      __html: body
    },
    ref: headingRef
  }));
};
Heading.propTypes = propTypes;
Heading.defaultProps = defaultProps;

// eslint-disable-next-line react/jsx-props-no-spreading
var Heading$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Heading, Object.assign({
    headingRef: ref
  }, props));
});

export { Heading$1 as default };
